module.exports = __webpack_public_path__ + "img/annual-report@2x.9a2c50fc.webp";